<template>
  <Box>
    <form class="dialog" onsubmit="return false" @keydown.esc="() => closeDialog(null)">
      <div class="header has-bcc-background has-text-white">
        <span>{{ fileName }}</span>
        <span title="Close">
          <i class="fas fa-times" style="cursor: pointer; color: #cd0000; font-size: 22px !important" aria-hidden="true" @click="() => closeDialog(null)" />
        </span>
      </div>

      <div class="body">
        <PdfViewer
          ref="pdfViewer"
          class="renderer"
          :class="{ ishidden: !canShowViewer }"
          :pdf="pdfData"
          :fileName="fileName"
          theme="light"
          :config="{
            toolbar: {
              toolbarViewerRight: false,
            },
          }"
        />
      </div>

      <div class="footer">
        <button class="button has-bcc-color is-small" @click="() => print()" :disabled="!pdfData" title="Print">
          <i class="fas fa-print"></i>
        </button>
        &nbsp; &nbsp;
        <button class="button has-bcc-color is-small" @click="() => closeDialog('download')" :disabled="!pdfData" title="Download">
          <i class="fas fa-download"></i>
        </button>
        &nbsp; &nbsp;
        <button class="button has-bcc-background has-text-white has-text-weight-semibold is-small" @click="() => closeDialog(null)">
          <i class="fas fa-times"></i>
          CLOSE
        </button>
      </div>
    </form>
  </Box>
</template>

<script setup>
import Box from './Box.vue'
import { useGlobalUtils } from '../../helpers/globalUtils'
import { closeDialog } from 'vue3-promise-dialog'
import { computed, nextTick, onMounted } from 'vue'
import { ref } from 'vue'

const { errorToast, successToast } = useGlobalUtils()

const pdfViewer = ref(null)
const canShowViewer = ref(false)

const props = defineProps({
  pdfData: {
    required: true,
    default: null,
  },
  fileName: {
    required: true,
    type: String,
    default: null,
  },
})

const windowWidth = computed(() => `${window.innerWidth}px`)
const windowHeight = computed(() => `${window.innerHeight - window.innerHeight * 0.12}px`)

const print = () => {
  if (pdfViewer.value) {
    const blob = new Blob([pdfViewer.value.pdf], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)

    document.querySelectorAll('iframe[id="print-iframe"]').forEach((iframe) => iframe.remove())
    let iframe = document.createElement('iframe')
    iframe.id = 'print-iframe'
    iframe.src = url
    iframe.style.position = 'absolute'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)

    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus()
        iframe.contentWindow.print()
      }, 1)
    }
  }

  setTimeout(() => {
    closeDialog(null)
  }, 1000)
}

onMounted(() => {
  setTimeout(() => {
    const errorWrapper = document.querySelector('#errorWrapper')
    const isHidden = errorWrapper?.hasAttribute('hidden')

    if (!isHidden) {
      canShowViewer.value = false
      errorToast('File preview is temporarily unavailable. Please download the file to view it.')
      closeDialog(null)
      return
    }

    canShowViewer.value = true
    successToast('Successfully loaded!')
  }, 500)
})
</script>

<style scoped lang="scss">
.dialog {
  display: flex;
  flex-direction: column;
  width: auto;
  height: auto;
  border-radius: 4px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;

    > div {
      display: flex;
      align-items: center;
      gap: 5px;

      > span {
        width: 20px;
      }
    }
  }

  .body {
    flex: 1;
    overflow-y: auto;
    background-color: white;

    .renderer {
      position: relative;
      height: v-bind(windowHeight);
      width: v-bind(windowWidth);
      right: -0;

      &.ishidden {
        right: 8000px;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    background-color: #ccc;
    border-top: 1px solid #666;
  }
}
</style>
